import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable/types'
import { fechaFormateada } from '../../../utils/dateHelper'
import { StockMovementKardexInfo } from '../types'

export const getColumnsConfig = (): TableColumn<StockMovementKardexInfo>[] => [
  {
    key: 'movementDate',
    title: 'Fecha/Hora',
    // Fecha arriba y hora abajo para que la columna sea más angosta/responsiva
    render: (value: string | number | boolean | undefined) => {
      if (value == null || value === '') return '-'
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ whiteSpace: 'nowrap' }}>
            {fechaFormateada(value as string, 'dd-MM-yyyy')}
          </span>
          <span style={{ whiteSpace: 'nowrap', color: '#666' }}>
            {fechaFormateada(value as string, 'HH:mm:ss')}
          </span>
        </div>
      )
    }
  },
  {
    key: 'marca',
    title: 'Marca',
    render: (value: string | number | boolean | undefined) => value || '-'
  },
  {
    key: 'originNumber',
    title: 'Nro Documento',
    headerTooltip: 'ASN o Nro Pedido',
    render: (value: string | number | boolean | undefined) => value || '-'
  },
  {
    key: 'sku',
    title: 'SKU',
    render: (value: string | number | boolean | undefined) => value || '-'
  },
  {
    key: 'warehouseCode',
    title: 'Almacén',
    render: (value: string | number | boolean | undefined) => value || '-'
  },
  {
    key: 'positionCode',
    title: 'Ubicación',
    render: (value: string | number | boolean | undefined) => value || '-'
  },
  {
    key: 'direccion',
    title: 'Dirección',
    align: 'center',
    render: (value: string | number | boolean | undefined) => value || '-'
  },
  {
    key: 'operacion',
    title: 'Operación',
    render: (value: string | number | boolean | undefined) => value || '-'
  },
  {
    key: 'quantity',
    title: 'Movimiento',
    align: 'center',
    render: (value: string | number | boolean | undefined) =>
      value == null ? 0 : value
  },
  {
    key: 'positionQtyBefore',
    title: 'Stock Antes',
    headerTooltip: 'Stock en la posición antes del movimiento',
    align: 'center',
    render: (value: string | number | boolean | undefined) =>
      value == null ? '-' : value
  },
  {
    key: 'positionQtyAfter',
    title: 'Stock Después',
    headerTooltip: 'Stock en la posición después del movimiento',
    align: 'center',
    render: (value: string | number | boolean | undefined) =>
      value == null ? '-' : value
  },
  {
    key: 'warehouseQtyAfter',
    title: 'Stock Almacén',
    headerTooltip: 'Stock total en el almacén después del movimiento',
    align: 'center',
    render: (value: string | number | boolean | undefined) =>
      value == null ? '-' : value
  }
]
